<!-- <main class="full-wrap dashboard-page">
    <div class="main-div">
        
        <div class="filterDiv">
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <div class="row form-field">
                            <div class="col-md-4">
                                <div class="col-inner">
                                    <div class="form-group dateTimePicker">
                                        <input type="text" class="form-control" [popover]="popTemplateStatementStart"
                                            placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                            value="{{statementStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="col-inner">
                                    <div class="form-group dateTimePicker">
                                        <input type="text" class="form-control" [popover]="popTemplateStatementEnd"
                                            placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                            value="{{statementEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" style="width: 20%;margin:0 5px 5px 5px;">
                                    
                              <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSport" 
                              (change)="getFilterData(searchSport.sport_id)" placeholder="Search Sport Name"
                                  >
                                  <ng-option *ngFor="let sport of SportList" [value]="sport">{{sport.sport_name}}</ng-option>
                              </ng-select>
                          </div>
                            <div class="col-md-6">
                                <div class="col-inner text-end">
                                    <div class="btn-list">
                                        <button type="button" class="btn btn-success" (click)="rollCommission('filterBtnClick')">Get P&L</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filterDiv">
            Rolling Commission
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="report-table">
                    <table class="table" datatable>
                        <thead>
                            <tr>
                                <th>Event Type</th>
                                        <th>Total Stack</th>
                                        <th>Total Commission</th>
                                        
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of rollCom;let i = index;">
                                <td >{{data?.event_name}}</td>
                                <td  [ngClass]="{'profit':data.stack >= 0}"> {{data.stack > '0' ? (data.stack | number :'0.0-2') : '0'}}</td>
                                <td [ngClass]="{'loss':data.user_commission_pl < 0}">{{data.user_commission_pl < '0' ? (data.user_commission_pl | number :'0.0-2') : '0'}}</td>
                            </tr>
                            <tr *ngIf="rollCom?.length == 0">No Record Found...</tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="right-sidebar">
            <div>
                <div class="card open-bet mb-0 b-none">
                    <div class="card-header card-accrdn openbetlist">
                        <strong>Open Bets</strong>
                    </div>
                    <div class="card-body">
                        <div class=" col-md-1" style="width: 100%;margin-bottom:9px;">
                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch"
                                (change)="openBets(searchMatch) "
                                placeholder="Search Match Name" >
                                <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="table-responsive" *ngIf="openBetsLength != 0" style="font-size: 12px;">
                            <table class="table"  *ngIf="backData?.length != 0">
                                <thead>
                                    <tr>
                                        <th>Back (Bet For)</th>
                                        <th>Odds</th>
                                        <th>Stake</th>
                                        <th>Profit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let bet of backData;let i = index;">
                                            <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet.is_back == 0 ? 'Lay' : "Back"}}
                                                <span>{{bet?.selection_name}}</span><br>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{bet?.market_name}}</span>
                                            </td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.odds}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.stack}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.p_l | number : '0.0-2'}}</td>
                                        </tr>
                                    <tr *ngIf="openBetsLength == 0">
                                        No Record Found ....
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table"  *ngIf="layData?.length != 0">
                                <thead>
                                    <tr>
                                        <th>Back (Bet Against)</th>
                                        <th>Odds</th>
                                        <th>Stake</th>
                                        <th>Liability</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let bet of layData;let i = index;">
                                            <td *ngIf="bet.is_fancy == 0" [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet.is_back == 0 ? 'Lay' : "Back"}}
                                                <span style="max-width: 20px !important;
                                                width: 20px !important;
                                                text-overflow: ellipsis;">{{bet?.selection_name}}</span><br>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{bet?.market_name}}</span>
                                            </td>
                                            <td *ngIf="bet.is_fancy == 1" [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet.is_back == 0 ? 'Lay' : "Back"}}
                                                <span>{{bet?.market_name}}</span><br>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>Fancy</span>
                                            </td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.odds}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}">{{bet?.stack}}</td>
                                              <td [ngClass]="{'pink':bet.is_back == 0,'blue':bet.is_back == 1}" style="color: red !important;">{{bet?.liability | number : '0.0-2'}}</td>
                                        </tr>
                                    
                                </tbody>
                            </table>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->



<div class="main-wrapper">
    <app-header></app-header>
    <div class="app-body position-relative">
        <app-sidebar></app-sidebar>
        <main class="main">
            <div class="row">
              <div class="col-md-12">
                <div class="divider-top">
                  <div class="card card-report card-accent-primary mb-3">
                    <div class="card-body p-0">
                      <div class="betHistory">
                        <div class="row">
                          <!-- <div class="col-md-4 col-6">
                            <div class="form-group mb-2">
                              <select class="form-select" aria-label="Default select example">
                                <option selected>Data Source</option>
                                <option value="1">LIVE DATA</option>
                                <option value="2">BACKUP DATA</option>
                                <option value="3">OLD DATA</option>
                              </select>
                            </div>
                          </div> -->
                          <div class="col-md-4 col-6">
                            <div class="form-group mb-2">
                              <!-- <select class="form-select" aria-label="Default select example">
                                <option>Select Sport</option>
                                <option selected value="1">Cricket</option>
                                <option value="2">Tennis</option>
                                <option value="3">Soccer</option>
                                <option value="4">Casino</option>
                                <option value="5">Horse Racing</option>
                              </select> -->
                              <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSport"   class="form-select"
                              (change)="getFilterData(searchSport.sport_id)" 
                                  >
                                  <ng-option *ngFor="let sport of SportList" [value]="sport">{{sport.sport_name}}</ng-option>
                              </ng-select>
                            </div>
                          </div>
                          <div class="col-md-4 col-6">
                            <div class="input-group mb-2">
                                <input type="text" class="form-control" [popover]="popTemplateStatementStart"
                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                value="{{statementStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                              <span class="input-group-text"><i class="fa fa-calendar-o"></i></span>
                            </div>                                      
                          </div>
                          <div class="col-md-4 col-6">
                            <div class="input-group mb-2">
                                <input type="text" class="form-control" [popover]="popTemplateStatementEnd"
                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                value="{{statementEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                              <span class="input-group-text"><i class="fa fa-calendar-o"></i></span>
                            </div>                                      
                          </div>                                    
                          <div class="col-md-4 col-12">
                            <div class="form-group mb-2">
                              <button class="btn btn-primary" type="button" (click)="rollCommission('filterBtnClick')"><strong>Get Commission</strong></button>
                            </div>                                      
                          </div>
                        </div>
                      </div>
                    </div>  
                  </div>
                  <div class="card card-accent-primary">
                    <div class="card-header account-detail-head">Rolling Commission</div>
                    <div class="card-body account-stat-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <table class="table table-bordered" datatable>
                              <thead>
                                <tr class="text-center">
                                  <th>Type</th>
                                  <th>Total Stack</th>
                                  <th>Total Commission</th>
                                </tr>
                              </thead>
                              <tbody *ngIf="rollCom?.length != 0">
                                <tr *ngFor="let data of rollCom;let i = index;" style="text-align: center;">
                                    <td>{{data?.event_name}}</td>
                                    <td> {{data.stack > '0' ? (data.stack | number :'0.0-2') : '0'}}</td>
                                    <td>{{data.user_commission_pl < '0' ? (data.user_commission_pl | number :'0.0-2') : '0'}}</td>
                                </tr>
                              </tbody>
                              <tbody *ngIf="rollCom?.length == 0">
                                <tr>
                                  <td class="no-data-available" colspan="3">No data!</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </main>
       <app-right-sidebar></app-right-sidebar>               
    </div>
    <app-footer-main></app-footer-main>
</div>
<!-- Date Time Picker -->
<ng-template #popTemplateStatementStart>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateStatement" [ngModelOptions]="{standalone: true}" [minDate]="minDate"  [maxDate] ="todayDateTime"[showWeeks]="false"
        (ngModelChange)="updateDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime" (ngModelChange)="updateTimeStatement()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateStatementEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateStatement" [ngModelOptions]="{standalone: true}" [minDate]="dateStatement" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime"  (ngModelChange)="updateEndTimeStatement()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>